import { render, staticRenderFns } from "./AtomImageSquared.vue?vue&type=template&id=3349b8c1&scoped=true"
import script from "./AtomImageSquared.vue?vue&type=script&setup=true&lang=js"
export * from "./AtomImageSquared.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3349b8c1",
  null
  
)

export default component.exports